module.exports = __webpack_public_path__ + "static/media/PFDinTextPro-Regular.26dee5b3.ttf";